import React from "react";
import "./App.css";
import trigon from "./assets/trigon.jpg";
import Check from "./components/Check/Check";
import LargeInput from "./components/InputCmpnt/LargeInput";
import Numberbar from "./components/Numberbar/Numberbar";
import Sidebar from "./components/Sidebar/Sidebar";

function App() {
  const [value, setValue] = React.useState({
    A1: "",
    A2: "",
    B1: "",
    B2: "",
    B3: "",
    C1: "",
    C2: "",
    C3: "",
    C4: "",
    C5: "",
    C6: "",
    C7: "",
    C8: "",
    D1: "",
    D2: "",
    D3: "",
    D4: "",
    E1: "",
    E2: "",
    E3: "",
    E4: "",
    E5: "",
    E6: "",
    E7: "",
    E8: "",
    F1: "",
    F2: "",
    F3: "",
    G1: "",
    G2: "",
    G3: "",
    G4: "",
    G5: "",
    G6: "",
    H1: "",
    H2: "",
  });
  const [sideValue, setSideValue] = React.useState({
    "000": false,
    "001": false,
    "002": false,
    "003": false,
    "013": false,
    "023": false,
    "033": false,
    133: false,
    233: false,
    333: false,
    "011": false,
    "012": false,
    "022": false,
    113: false,
    123: false,
    223: false,
    111: false,
    112: false,
    122: false,
    222: false,
  });
  const setStateValue = (number) => {
    setValue({ ...value, [selected]: number });
  };
  const [selected, setSelected] = React.useState("");
  return (
    <>
      <Numberbar setStateValue={setStateValue} />
      <div className="w-screen flex justify-center">
        <div className="flex md:justify-center w-[360px] md:w-10/12 flex-col-reverse lg:flex-row lg:w-[80rem] relative">
          <div className="w-full lg:w-[32rem] flex items-center justify-center xl:justify-start">
            <Sidebar value={sideValue} setValue={setSideValue} />
          </div>
          <div className="md:w-[768px] lg:w-[48rem] h-[30rem] lg:h-[38rem]">
            <div className="">
              <LargeInput value={value} setSelected={setSelected} />
            </div>

            <div className="w-full flex justify-center lg:justify-start">
              <img
                src={trigon}
                alt="trigon"
                className="h-[30rem] lg:h-[40rem] absolute"
              />
            </div>
          </div>
        </div>
      </div>
      <Check value={value} setValue={setValue} setSideValue={setSideValue} />
    </>
  );
}

export default App;
